import React from 'react';
import { CalculationRow } from 'features/ShoppingCart/components/CartSummary/styles';
import { currencyFormat } from 'utils';
import { useTranslation } from 'react-i18next';
import usePoints from 'hooks/usePoints';
import { useBrandCurrency } from 'hooks/useBrandCurrency';
import styled from 'styled-components';

interface CartSummaryTotalProps {
  cartTotal: number;
  isPayingWithPoints?: boolean;
}

const CartSummaryTotal = ({
  cartTotal,
  isPayingWithPoints,
}: CartSummaryTotalProps) => {
  const { t } = useTranslation();
  const currency = useBrandCurrency();
  const { count: cartTotalPoints } = usePoints(cartTotal);

  return (
    <CalculationRow className="cart-summary-total">
      {cartTotal === 0 ? (
        <ComplimentaryText>{t('complimentary')}</ComplimentaryText>
      ) : (
        <>
          <span>{t('total')}:</span>
          {isPayingWithPoints ? (
            <span>{t('pointsWithCount', { count: cartTotalPoints })}</span>
          ) : (
            <span>{currencyFormat(currency)(cartTotal)}</span>
          )}
        </>
      )}
    </CalculationRow>
  );
};

const ComplimentaryText = styled.span`
  font-size: 14px;
  line-height: 22px;
  color: var(--way-colors-textColor);
`;

export default CartSummaryTotal;
